module.exports = __webpack_public_path__ + "static/media/bunnylever2.5590d81a.png";